import BoardTreeItem from './BoardTreeItem';

export default BoardTreeItem;
